import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
import { colors } from '../theme';

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.14, delayChildren: 0.1 } },
};
const rise = {
  hidden: { opacity: 0, y: 44 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.95, ease: [0.22, 1, 0.36, 1] } },
};

export default function Hero() {
  const reduce = useReducedMotion();
  const ref = React.useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });

  const y = useTransform(scrollYProgress, [0, 1], [0, 180]);
  const opacity = useTransform(scrollYProgress, [0, 0.75], [1, 0]);
  const cueOpacity = useTransform(scrollYProgress, [0, 0.12], [1, 0]);

  return (
    <Box
      id="top"
      ref={ref}
      sx={{
        position: 'relative',
        minHeight: '100svh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: colors.white,
        backgroundImage:
          'radial-gradient(120% 80% at 50% -20%, #eaf3ff 0%, rgba(255,255,255,0) 55%)',
      }}
    >
      <MotionBox style={reduce ? undefined : { y, opacity }} sx={{ width: '100%' }}>
        <Container sx={{ textAlign: 'center' }}>
          <MotionBox
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            <MotionTypography variants={rise} variant="overline"
              sx={{ color: colors.inkSoft, letterSpacing: '0.28em', fontSize: '0.8rem' }}>
              SOFTWARE ENGINEER
            </MotionTypography>

            <MotionTypographyName />

            <MotionTypography
              variants={rise}
              variant="subtitle1"
              sx={{ color: colors.inkSoft, maxWidth: 620, mx: 'auto', mt: 3, px: 2 }}
            >
              Experienced developer providing high-quality software solutions.
            </MotionTypography>
          </MotionBox>
        </Container>
      </MotionBox>

      <MotionBox
        style={reduce ? undefined : { opacity: cueOpacity }}
        sx={{
          position: 'absolute',
          bottom: 34,
          left: 0,
          right: 0,
          textAlign: 'center',
          color: colors.inkSoft,
        }}
      >
        <Typography variant="caption" sx={{ letterSpacing: '0.2em', textTransform: 'uppercase' }}>
          Scroll
        </Typography>
        <motion.div
          animate={reduce ? undefined : { y: [0, 8, 0] }}
          transition={{ duration: 1.7, repeat: Infinity, ease: 'easeInOut' }}
        >
          <KeyboardArrowDownRoundedIcon />
        </motion.div>
      </MotionBox>
    </Box>
  );
}

function MotionTypographyName() {
  return (
    <MotionTypography
      variants={rise}
      component="h1"
      variant="h1"
      sx={{ mt: 1.5 }}
    >
      Adrian{' '}
      <Box
        component="span"
        sx={{
          background: `linear-gradient(90deg, ${colors.blue}, #7d4bff)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        Chesnoiu
      </Box>
    </MotionTypography>
  );
}
